import { useMutation } from '@tanstack/react-query'

import {
  createCancelPortalSession,
  createPortalSession,
} from '../dal/stripe-dal'

export function useCreatePortalSession() {
  return useMutation({
    mutationFn: createPortalSession,
  })
}

/**
 * Mutation hook to create a Stripe customer portal session that sends the user
 * directly to the subscription cancellation flow (when the backend supports it).
 * Backend should create a session with Stripe flow_data.type = `subscription_cancel`.
 * Returns the portal session URL.
 */
export function useCreateCancelPortalSession() {
  return useMutation({
    mutationFn: createCancelPortalSession,
  })
}
